import { useQuery } from '@tanstack/react-query';
import AiChatService from '../Services/ai-chat/AiChat';

export const AI_CHAT_QUERY_KEY = 'ai-chat';

export const aiChatKeys = {
  all: [AI_CHAT_QUERY_KEY],
  teachers: () => [AI_CHAT_QUERY_KEY, 'teachers'],
  teacher: (teacherId) => [AI_CHAT_QUERY_KEY, 'teachers', teacherId],
  teacherSessions: (teacherId) => [AI_CHAT_QUERY_KEY, 'sessions', 'teacher', teacherId],
  session: (sessionId) => [AI_CHAT_QUERY_KEY, 'sessions', sessionId],
  sessionTokens: (sessionId) => [AI_CHAT_QUERY_KEY, 'sessions', sessionId, 'tokens'],
};

export const useGetAiChatTeachers = () => {
  return useQuery({
    queryKey: aiChatKeys.teachers(),
    queryFn: AiChatService.getTeachers,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useGetAiChatTeacher = (teacherId) => {
  return useQuery({
    queryKey: aiChatKeys.teacher(teacherId),
    queryFn: () => AiChatService.getTeacher(teacherId),
    enabled: Boolean(teacherId),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useGetAiChatTeacherSessions = (teacherId) => {
  return useQuery({
    queryKey: aiChatKeys.teacherSessions(teacherId),
    queryFn: () => AiChatService.getTeacherSessions(teacherId),
    enabled: Boolean(teacherId),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useGetAiChatSession = (sessionId) => {
  return useQuery({
    queryKey: aiChatKeys.session(sessionId),
    queryFn: () => AiChatService.getSession(sessionId),
    enabled: Boolean(sessionId),
    staleTime: 15 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useGetAiChatSessionTokenCount = (sessionId) => {
  return useQuery({
    queryKey: aiChatKeys.sessionTokens(sessionId),
    queryFn: () => AiChatService.getSessionTokenCount(sessionId),
    enabled: Boolean(sessionId),
    staleTime: 30 * 1000,
    refetchOnWindowFocus: false,
  });
};
